import { Component, OnInit, inject, signal } from '@angular/core';
import { IBizEntity, BizEntityTypeCategory, LoggerService } from '@optima-stride-ai/core';
import { BizEntityTypeStateStoreService, FormBizEntityComponent } from '@optima-stride-ai/optima-app-framework';
import { createNewBizEntity } from '../biz-entity.factory';
import { GlobalStateService } from '../../../../../service/global.service';
import { LibraryExplorerStateService } from '../../../libraries/services/library-explorer-state.service';



@Component({
  selector: 'app-form-add-library-folder',
  imports: [FormBizEntityComponent],
  templateUrl: './form-add-library.component.html',
  styleUrls: ['./form-add-library.component.sass'],
})

export class FormAddLibraryComponent implements OnInit {
  private readonly logger = inject(LoggerService);
  private readonly bizEntityTypeStateStoreService = inject(BizEntityTypeStateStoreService);
  private readonly global = inject(GlobalStateService);
    private readonly libraryExplorerStateService = inject(LibraryExplorerStateService);
  
  public selectedBizEntityId: string | null = null;
  public bizEntity = signal<IBizEntity | null>(null);
  public isEditing = false;
  
  async ngOnInit(): Promise<void> {
    // Subscribe to selected entity ID to set as parent
    this.global.selectedBizEntityId$.subscribe((id) => {
      this.selectedBizEntityId = id;
    });
    // Initialize the bizEntity for creating a new library
    await this.initializeBizEntity();
  }
  OnSaveCompleted(event: any): void {
    if (event.success) {
      this.global.setBizEntityCreated(true);
    }
  }
  private async initializeBizEntity(): Promise<void> {
    // Get entity types to set the correct type for library folder
    const entityTypes = await this.bizEntityTypeStateStoreService.getState();
    const libraryType = entityTypes?.find(type => type.category === BizEntityTypeCategory.HayagrivaLibrary);
    
    if (!libraryType) {
      this.logger.error('❌ Library Folder Type not found in entity types');
      return;
    }
    
    this.logger.info(`📚 Library Folder Type found: ${libraryType.name} (${libraryType.id})`);
    
    // Initialize empty bizEntity for creation
    const newBizEntity = createNewBizEntity(
      libraryType,
      this.selectedBizEntityId || '',
      'cilLibrary',
      ['Library']
    );
    this.libraryExplorerStateService.setSelectedParentId(this.selectedBizEntityId || '');

    // Set the signal to trigger change detection
    this.bizEntity.set(newBizEntity);
    
    this.logger.info(`📚 Form Add Library initialized with parent: ${this.selectedBizEntityId}`);
  }
}


//createblankbizentity// bizentity factory//